@if (isFormShown) {
<div id="set-password" fxLayout="column" linPerfectScrollbar>
  <div id="set-password-form-wrapper" fxLayout="column" fxLayoutAlign="center center">
    <div id="set-password-form">
      <div class="logo">
        <img [src]="(platformSettings$ | async)?.logoUrl" />
      </div>

      <div class="title">{{ 'NEW_PASSWORD.TITLE_TEXT' | translate }}</div>

      @if (formError) {
      <div class="lin-form-error">{{ formError }}</div>
      }

      <form [formGroup]="form" (ngSubmit)="changePassword()">
        <mat-form-field appearance="outline">
          <input
            matInput
            #password
            [type]="showPassword ? 'text' : 'password'"
            required
            formControlName="password"
            placeholder="{{ 'FIELDS.PASSWORD' | translate }}"
          />
          <button
            mat-icon-button
            matSuffix
            type="button"
            [disableRipple]="true"
            (click)="showPassword = !showPassword"
            [attr.aria-label]="(showPassword ? 'FIELDS.HIDE_PASSWORD' : 'FIELDS.SHOW_PASSWORD') | translate"
            data-testid="btn-toggle-password"
          >
            <mat-icon>{{ showPassword ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          <mat-error>
            <lin-form-field-error></lin-form-field-error>
          </mat-error>
          @if (form.get('password').hasError('hasCapitalCase')) {
          <mat-error> {{ 'NEW_PASSWORD.UPPER_CASE_CRITERIA' | translate }} </mat-error>
          } @if (form.get('password').hasError('hasSmallCase')) {
          <mat-error> {{ 'NEW_PASSWORD.LOWER_CASE_CRITERIA' | translate }} </mat-error>
          } @if (form.get('password').hasError('hasNumber')) {
          <mat-error> {{ 'NEW_PASSWORD.DIGITS_CRITERIA' | translate }} </mat-error>
          } @if (form.get('password').hasError('hasSpecialCharacters')) {
          <mat-error> {{ 'NEW_PASSWORD.SPECIAL_CHARS_CRITERIA' | translate }} </mat-error>
          }
        </mat-form-field>

        <lin-password-strength [password]="password.value"></lin-password-strength>

        <button
          mat-raised-button
          color="accent"
          type="button"
          class="button-block generate"
          [disabled]="isDisabled"
          (click)="generatePassword()"
        >
          {{ 'NEW_PASSWORD.BUTTON.TEXT_GENERATE' | translate }}
        </button>

        <lin-form-submit-button [isLoading]="isSubmitting">
          <span>{{ 'NEW_PASSWORD.BUTTON.SET_PASSWORD' | translate }}</span>
        </lin-form-submit-button>
      </form>
    </div>
  </div>
</div>
}
